{
  "accessRights": {
    "canManageAccessRightsTooltip": "Die Lehrkraft kann weitere Kolleg:innen zur Klasse hinzufügen und deren Zugriffsrechte verwalten.",
    "canManageCompetencesTooltip": "Die Lehrkraft kann Fächer und deren Kompetenzen flexibel erstellen, anpassen und löschen.",
    "canManagePerformanceAssessmentsTooltip": "Die Lehrkraft kann Leistungsfeststellungen jederzeit erstellen, bearbeiten und entfernen.",
    "canManageStudentsTooltip": "Die Lehrkraft kann Schüler:innen jederzeit anlegen, bearbeiten und aus der Klasse entfernen.",
    "removeDescription": "Bist du sicher, dass du diese Lehrkraft aus der Klasse entfernen möchtest?",
    "removeTitle": "Lehrkraft entfernen"
  },
  "auth": {
    "deletedUser": "Gelöschte Lehrkraft"
  },
  "billing": {
    "checkoutProductDialog": {
      "teacherQuestion": "Wie viele Lehrkräfte?"
    },
    "products": {
      "team": {
        "checkoutDescriptionUnit": "Lehrkräfte",
        "checkoutMonthlyLine": "{price} pro Lehrkraft und Monat",
        "checkoutYearlyLine": "{price} pro Lehrkraft und Jahr",
        "pricing": "<b>{perSeat}</b> für jede Lehrkraft und Jahr",
        "pricingCalculatorDescription": "{price} pro Lehrkraft und Jahr"
      },
      "units": {
        "perTeacherPerMonth": "pro Lehrkraft und Monat"
      }
    }
  },
  "classTeam": {
    "tip": "Hier siehst du alle Lehrkräfte, die in deiner Klasse <b>{currentClass}</b> unterrichten. Berechtigungen und Freigaben für Fächer sind hier einsehbar und können nur von Admins geändert werden. Je nach eigener Berechtigung kannst du weitere Lehrkräfte zur Klasse hinzufügen."
  },
  "classes": {
    "addSchoolSubjectFromOtherLevels": "Kompetenzen aus anderen Klassenstufen hinzufügen",
    "bumpUpClassSelectModeDescription": "Willst du eine neue Klasse erstellen, oder eine Klasse hochstufen?",
    "bumpUpDescription": "Stufe eine bestehende Klasse in die nächste Klassenstufe hoch. Schülerinnen und Schüler, sowie Zugriffsrechte werden übernommen.",
    "generalDataDescription": "Lass uns eine neue Klasse erstellen. Bitte lege Klassenstufe und Name fest.",
    "newSchoolLevel": "Neue Klassenstufe",
    "tipAdmin": "Hier kannst du Klassen erstellen und bearbeiten. Du siehst auf einen Blick die zuständigen Lehrkräfte sowie die Anzahl der Schülerinnen und Schüler – beides lässt sich direkt einsehen und verwalten."
  },
  "general": {
    "schoolLevel": "Klassenstufe",
    "schoolLevelCount": "1 Klassenstufe | {count} Klassenstufen",
    "schoolLevelOption": "Klassenstufe { schoolLevel }",
    "schoolLevelsContinuousHint": "Klassenstufen müssen zusammenhängend sein — keine Lücken erlaubt (z. B. 1–6).",
    "schoolTerm": "Halbjahr",
    "teachers": "Lehrkräfte",
    "willBeInvitedDescription": "Die Lehrkraft erhält im Anschluss eine Einladung deinem <b>Team beizutreten</b> und kann danach gleich in dieser Klasse loslegen."
  },
  "gradeCalculation": {
    "disclaimer": "Die berechneten Noten dienen als Orientierung. Die abschließende Beurteilung und Verantwortung für die Notengebung liegt bei der Lehrkraft.",
    "schoolLevels": {
      "dialogDescription": "Für welche Klassenstufen soll die Notenempfehlung verwendet werden?",
      "dialogTitle": "Klassenstufen",
      "scopeAll": "alle Klassenstufen",
      "scopeMultiple": "Klassenstufen {schoolLevels}",
      "scopePreSchoolAndMultiple": "die Vorschulstufe sowie Klassenstufen {schoolLevels}",
      "scopePreSchoolAndSingle": "die Vorschulstufe sowie Klassenstufe {schoolLevel}",
      "scopeSingle": "Klassenstufe {schoolLevel}"
    }
  },
  "groups": {
    "canManageAccessRightsTooltip": "Die Lehrkraft kann weitere Kolleg:innen zur Gruppe hinzufügen und deren Zugriffsrechte verwalten.",
    "canManageStudentsTooltip": "Die Lehrkraft kann Schüler:innen jederzeit anlegen, bearbeiten und aus der Gruppe entfernen.",
    "levelAndGroup": "Klassenstufe / Gruppe",
    "teamMemberRemoveDescription": "Bist du sicher, dass du diese Lehrkraft aus der Gruppe entfernen möchtest?",
    "teamMemberWillBeInvitedDescription": "Die Lehrkraft erhält im Anschluss eine Einladung deinem <b>Team beizutreten</b> und kann danach gleich in dieser Gruppe loslegen.",
    "teamTip": "Hier siehst du alle Lehrkräfte, die in deiner Gruppe <b>{currentClass}</b> unterrichten. Berechtigungen und Freigaben für Fächer sind hier einsehbar und können nur von Admins geändert werden. Je nach eigener Berechtigung kannst du weitere Lehrkräfte zur Gruppe hinzufügen.",
    "tipAdmin": "Hier kannst du Gruppen erstellen und verwalten. In Gruppen kannst du Schüler:innen klassen- und jahrgangsübergreifend zusammenfassen – zum Beispiel für Förder-, Chor- oder Leistungsgruppen."
  },
  "inviteUser": {
    "teacher": {
      "title": "Lehrkräfte einladen"
    }
  },
  "schoolSubject": {
    "schoolLevel": "Klassenstufe",
    "allSchoolLevels": "Alle Klassenstufen"
  },
  "externalMaterial": {
    "schoolLevels": "Klassenstufen"
  },
  "onboarding": {
    "checkout": {
      "billedPerTeachers": "Abrechnung nach Lehrkräften",
      "perTeacherPerMonth": "pro Lehrkraft und Monat",
      "summary": {
        "teachersLine": "Lehrkräfte",
        "unlimitedTeachers": "Unbegrenzte Lehrkräfte"
      },
      "teacherQuantityLabel": "Anzahl Lehrkräfte"
    },
    "class": {
      "schoolLevel": "Klassenstufe"
    },
    "schoolLevels": {
      "edit": "Klassenstufen bearbeiten",
      "editConfirmDescription": "Bitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um die Klassenstufen zu bearbeiten.",
      "editConfirmHint": "Die entfernten Klassenstufen werden auch aus den Kompetenzvorlagen deiner Schule entfernt. Bestehende Klassen sind davon nicht betroffen.",
      "editDescription": "Welche Klassenstufen umfasst deine Schule?",
      "title": "Bitte wähle nun die Klassenstufen für deine “{schoolTypeName}”."
    },
    "schoolSubject": {
      "title": "Super, wir haben für dich schon mal alle Kompetenzen für Klassenstufe {schoolLevel} vorbereitet."
    }
  },
  "performanceAssessment": {
    "hint": "Hier legst du fest, wie die Leistungen in den einzelnen Klassenstufen und Halbjahren dokumentiert werden sollen. Für die Kompetenzerfassung steht dir bereits eine Vorlage zur Verfügung."
  },
  "referral": {
    "postReleaseDialog": {
      "description": "Digidoo wächst durch Empfehlungen von Lehrkräften wie dir. Wenn Digidoo dir hilft, freuen wir uns über jede Weiterempfehlung."
    },
    "reportSuccessDialog": {
      "description": "Hilf anderen Lehrkräften, auch Zeit bei der Dokumentation zu sparen."
    }
  },
  "reports": {
    "competencesSchoolLevel": "Kompetenzen Klassenstufe {schoolLevel}",
    "firstSemester": "1. Halbjahr",
    "generalData": {
      "term": "Halbjahr"
    },
    "hideInputValues": "Textfelder von Hand ausfüllen",
    "level": "Klassenstufe {schoolLevel}",
    "levelAndClass": "Klassenstufe / Klasse",
    "overview": {
      "access": "Folgende Lehrkräfte haben Zugriff"
    },
    "schoolYearTerm": "Schuljahr / Halbjahr",
    "secondSemester": "2. Halbjahr",
    "summarySheet": {
      "teacher": "Lehrkraft"
    }
  },
  "schoolSubjects": {
    "confirm": {
      "descriptionDifferentSchoolType": "Du hast Fächer aus Klassenstufe {sourceGrade} ({sourceSchoolType}) ausgewählt. Möchtest du sie wirklich in die {targetLabel} deiner Schule importieren?"
    },
    "filter": "Klassenstufe { schoolLevel }",
    "filteredEmptyStateDescription": "Für die ausgewählte Klassenstufe wurden keine Fächer gefunden.",
    "filteredEmptyStateTitle": "Keine Fächer für diese Klassenstufe",
    "fromTemplateHelpTextClass": "Fehlt dir ein Förderschwerpunkt, Wahlfach usw.? Bitte <a class=\"underline hover:no-underline\" href=\"{ mailto }\">kontaktiere deine Schulleitung.</a>",
    "fromTemplateHelpTextMailBody": "Hallo { firstNameReceiver },\n\nbitte erstelle mir diese Kompetenz:\n\nBeste Grüße,\n{ firstNameSender }\n\n----\nPS: Als Digidoo Administration findest du alle verfügbaren Kompetenzvorlagen (z. B. Förderschwerpunkte, Wahlfächer, Religionen usw.) unter Schuladministration -> Kompetenzraster -> Hinzufügen. Diese können den Klassen direkt freigeschaltet werden und anschließend von der Lehrkraft importiert werden.\n",
    "selection": {
      "addTeachers": "Lehrkräfte hinzufügen",
      "differentTeachersDescription": "Unterschiedliche Lehrkräfte haben Zugriff:",
      "manageTeachers": "Lehrkräfte verwalten",
      "teacherCount": "{count} Lehrkraft | {count} Lehrkräfte",
      "teachersDescription": "Folgende Lehrkräfte haben Zugriff:",
      "teachersTab": "Lehrkräfte"
    },
    "tipAdmin": "Hier siehst du alle Kompetenzen aller Klassenstufen. Du kannst Fächer, Kompetenzbereiche und einzelne Kompetenzen bearbeiten, neu anlegen oder aus einer Vorlage hinzufügen. Diese Kompetenzen dienen als schulweite Vorlage und können – je nach Zugriffsrechten – von Lehrkräften in den Klassen bearbeitet oder übernommen werden.",
    "tipTeacher": "Hier legst du fest, welche Kompetenzen im Unterricht eingesetzt werden, welche Lehrkräfte die jeweiligen Fächer unterrichten und für welche Schülerinnen und Schüler diese Kompetenzen gelten."
  },
  "schoolYears": {
    "startDate": "{term}. Halbjahr",
    "term": "Halbjahr {term}",
    "termValidation": {
      "firstTermBeforeSecondTerm": "Das erste Halbjahr muss vor dem zweiten liegen"
    }
  },
  "templateSet": {
    "upload": {
      "hiddenSchoolLevels": "Der gewählte Schultyp hat die Klassenstufen {levels} aus der Datei nicht. Deren Fächer werden nicht angezeigt.",
      "noMatchingSchoolLevels": "Die Datei enthält nur Fächer der Klassenstufen {fileLevels}, der gewählte Schultyp hat die Klassenstufen {schoolTypeLevels}. Bitte wähle einen passenden Schultyp.",
      "schoolLevelsMismatch": "Die Datei enthält keine Fächer für die Klassenstufen des gewählten Schultyps."
    }
  },
  "tenants": {
    "changeSchoolTypeConfirm": {
      "hint": "Bestehende Klassenstufen, Klassen, Fächer und Bewertungen bleiben unverändert. Künftig verfügbare Lehrplan- und Fachvorlagen richten sich nach dem neuen Schultyp."
    }
  },
  "performanceAssessmentCatalog": {
    "homework": "Hausaufgabe",
    "oral-exercise": "Mündliche Leistung",
    "written-exam": "Klassenarbeit"
  },
  "supportMeasureEntry": {
    "materials": {
      "otherSchoolLevel": "Andere Klassenstufe"
    }
  }
}
